<template>
  <div
    class="mai-logo flex flex-middle flex-center"
    :style="dimensions"
  >
    <img
      ref="nonBannerImage"
      v-if="valid"
      v-show="!imageError"
      :class="[imageClass, 'actual']"
      :src="rawURL"
      :title="imageTitle"
      :style="dimensions"
      :alt="imageAlt"
      :width="width || 'auto'"
      :height="height || 'auto'"
    />
    <slot></slot>
  </div>
</template>
<script>
import api from '@/api'
export default {
  name: 'MaiImage',
  props: {
    src: {
      type: String,
      required: false
    },
    imageClass: {
      type: String,
      required: false,
      default: ''
    },
    tenantId: {
      type: String,
      required: false,
      default: ''
    },
    height: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    alt: {
      type: String
    },
    title: {
      type: String
    }
  },
  data () {
    return {
      init: false,
      imageError: false,
      file: {
        blob: null,
        entity: {
          originalName: null,
          mimeType: null
        }
      },
      rawURL: ''
    }
  },
  computed: {
    imageTitle () {
      return this.title || this.alt || (this.file && this.file.entity && this.file.entity.originalName)
    },
    imageAlt () {
      return this.alt || this.title || (this.file && this.file.entity && this.file.entity.originalName)
    },
    dimensions () {
      const obj = {}
      if (this.height) { obj.height = this.height }
      if (this.width) { obj.width = this.width }
      return obj
    },
    dataURI () {
      return `data:${this.file.entity.mimeType};base64,${this.file.blob}`
    },
    valid () {
      return this.src && localStorage.getItem('token')
    },
    styles () {
      const obj = { maxWidth: '100%' }
      if (this.file.entity.opacity) {
        obj.opacity = this.file.entity.opacity
      }
      return obj
    }
  },
  methods: {
    handleError () {
      this.imageError = true
      this.$emit('error')
    },
    getRawURL () {
      const base = api.GET_RAW_MEDIA(this.src, localStorage.getItem('token'))
      return base + (this.tenantId ? `&tenantId=${this.tenantId}` : '')
    },
    setRawURL () {
      this.rawURL = this.getRawURL()
    }
  },
  watch: {
    src () {
      this.imageError = false
    }
  },
  mounted () {
    if (this.src && !this.src.trim().length) {
      this.handleError()
    } else {
      this.setRawURL()
      this.$nextTick(() => {
        const nonBan = this.$refs.nonBannerImage
        if (nonBan) { nonBan.onerror = this.handleError }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/sections/chat/MaiImage.vue